export default "__VITE_ASSET__d8c744f0__"